/*
  src/redux/answers/constants.js

  Created by Justin Chang on 6/15/2017.
*/

import { createConstant } from '../helpers';
const createConstantVariable = createConstant('answers');

// SET Constants
export const SET_ENGAGEMENT_ANSWER = createConstantVariable('SET_ENGAGEMENT_ANSWER');
export const SET_ENGAGEMENT_ANSWER_SENT_TO_API = createConstantVariable('SET_ENGAGEMENT_ANSWER_SENT_TO_API');

// REMOVE Constants
export const REMOVE_ENGAGEMENT_ANSWERS = createConstantVariable('REMOVE_ALL_ENGAGEMENT_ANSWERS');

// FAILURE Constants
export const FAIL_TO_SET_ENGAGEMENT_ANSWER = createConstantVariable('FAIL_TO_SET_ENGAGEMENT_ANSWER');
export const FAIL_TO_REMOVE_ENGAGEMENT_ANSWER = createConstantVariable('FAIL_TO_REMOVE_ENGAGEMENT_ANSWER');
export const FAIL_TO_SEND_ENGAGEMENT_ANSWER_TO_API = createConstantVariable('FAIL_TO_SET_ENGAGEMENT_ANSWER');



// WEBPACK FOOTER //
// ./src/redux/answers/constants.js